/* eslint-disable react/react-in-jsx-scope */
import LoginForm from "@/auth/components/LoginForm";
import RegistrationForm from "@/auth/components/RegistrationForm";
import { useAuth } from "@/auth/hooks/useAuth";
import { LoadingSpinner } from "@/components/ui/loadingSpinner";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import useCheckIsDevice from "@/hooks/useDeviceType";
import { useNavigate, useSearchParams, useLocation , useParams } from "react-router-dom";
import {
  HandCoins,
  FolderPlus,
  LineChart,
  KeyRound,
} from 'lucide-react';
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { Trans } from "react-i18next";


const Registration = () => {
  const navigate = useNavigate();
  const { isAuthenticated, user, loading } = useAuth();

  const { t } = useTranslation("auth", {
      keyPrefix: "register",
    });
  const { i18n } = useTranslation();
  
  const [link1, setLink1] = useState("https://verdeo.fr/financer-des-projets/");
  const [link2, setLink2] = useState("https://verdeo.fr/projet/");
  const [link3, setLink3] = useState("https://verdeo.fr/contact/");

  const currentLanguage = i18n.language;
  useEffect(() => {
    if(currentLanguage === "fr") {
      setLink1("https://verdeo.fr/contact?type=financing");
      setLink2("https://verdeo.fr/contact?type=search-financing");
      setLink3("https://verdeo.fr/contact?type=sas");
    } else {
      setLink1("https://verdeo.fr/en/contact-us?type=financing");
      setLink2("https://verdeo.fr/en/contact-us?type=search-financing");
      setLink3("https://verdeo.fr/en/contact-us?type=sas")
    }
  },[currentLanguage])
 
  const cards = [
    {
      id: 1,
      title: t("Je veux financer"),
      description: t("Je souhaite financer des projets de haute qualité environnementale"),
      icon: HandCoins,
      link:link1
    },
    {
      id: 2,
      title: t("Je cherche un financement"),
      description: t("Je souhaite un code d'accès pour déposer un projet à financer"),
      icon: FolderPlus,
      link: link2
    },
    {
      id: 3,
      title: t("Je cherche un outil de suivi"),
      description: t("Je suis un porteur de projets qui souhaite utiliser Verdeo comme outil de suivi"),
      icon: LineChart,
      link: link3
    },
    {
      id: 4,
      title: t("J'ai déjà un code d'accès"),
      description: t("J'ai un code d'accès et je voudrais m'inscrire"),
      icon: KeyRound,
      link:""
    },
  ];

   const handleClick = (card) => {
    if(card.id != 4) {
      window.location.href = card.link;
    } else {
      navigate(`/access-code`);
    }
    
  };
  const isMobile = useCheckIsDevice("mobile");
  if (isAuthenticated && user?.isVerified) {
    if(user?.status === 1) {
      navigate(`/dashboard`);
    } /*else if (redirect) {
      window.location.href = redirect;
    } */else {
      navigate(`/submit/programs`);
    }
    return <></>;
  }

  if (loading)
    return (
      <div className="container min-h-screen">
        <LoadingSpinner />
      </div>
    );
  //Todo: Rédirection de l'utilisateur vers la page code s'il n'est pas vérifié et on lui envoie un code mail
  return (
    // <div className="container">
    //   {isMobile ? (
    //     <Tabs defaultValue="login" className="w-full">
    //       <TabsList className="mb-2 grid w-full grid-cols-2">
    //         <TabsTrigger value="login">Connexion</TabsTrigger>
    //         <TabsTrigger value="registration">Inscription</TabsTrigger>
    //       </TabsList>
    //       <TabsContent value="login" className="mb-4">
    //         <LoginForm />
    //       </TabsContent>
    //       <TabsContent value="registration" className="mb-4">
    //         <RegistrationForm />
    //       </TabsContent>
    //     </Tabs>
    //   ) : (
    //     <div className="mx-auto mb-5 mt-8 flex flex-wrap lg:w-3/4">
    //       <div className="basis-full md:basis-1/2 md:pl-6">
    //         <RegistrationForm />
    //       </div>
    //     </div>
    //   )}
    // </div>

    <div className="  p-6 flex items-center justify-center">
      <div className="w-full max-w-6xl">
        {/* TITRE + DESCRIPTION */}
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-4">
            {t("Choisissez votre profil pour démarrer avec Verdeo")}
          </h1>
          <p className="text-gray-600 max-w-2xl mx-auto">
            {t("Que vous soyez financeur, porteur de projets")}
          </p>
        </div>

        {/* GRILLE DES CARTES */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 ">
          {cards.map((card) => {
            const Icon = card.icon;
            return (
                <div
                  key={card.id}
                  onClick={() => handleClick(card)}
                  className="cursor-pointer rounded-xl bg-white shadow-md hover:shadow-lg transition-shadow duration-300 p-6 hover:bg-green-50"
                >
                  {/* Icône centrée */}
                  <div className="flex justify-center mb-4">
                    <Icon className="h-10 w-10 text-[#1d5214]" />
                  </div>

                  <h2 className="text-xl font-bold text-gray-800 text-center mb-2">{card.title}</h2>
                  <p className="text-gray-600 text-center">{card.description}</p>
                </div>
              )
            }
          )}
        </div>

        <div className="flex flex-col items-center text-center p-16 bg-white font-sans">
      

      <h1 className="text-3xl font-normal text-[#1d5214] mb-6">
        {t("Testez Verdeo gratuitement pendant 15 jours")}
      </h1>

      <p className="text-xl text-gray-700 max-w-3xl leading-relaxed mb-10 font-medium">
        {t("trial_section_description")}
      </p>

      <a
        href="https://trial.verdeo.fr/registration"
        className="bg-[#1d5214] hover:bg-[#145214] text-white font-bold py-4 px-8 rounded-full shadow-lg transition duration-300 flex items-center"
      >
        <span className="text-sm mr-2"></span>
        {t("Choisir mon essai de 15 jours")}
      </a>
      
      {/* Ligne de séparation (optionnelle) */}
      <hr className="w-1/4 border-t border-gray-300 mt-12" />
    </div>
      </div>
    </div>
  );
};

export default Registration;